import React, {useEffect, useState} from "react";
import style from "./CercaAssistentiFamiliari.module.css";
import {Row} from "react-bootstrap";
import Button from "../../components/Button/Button";
import Autocomplete from "../../components/Autocomplete/Autocomplete";
import RangeSlider from "../../components/RangeSlider/RangeSlider";
import CheckBox from "../../components/checkBox/CheckBox";
import Table from "../../components/table/Table";
import Pagination from "../../components/pagination/Pagination";
import {useHistory} from "react-router";
import Utils from "../../utils/Utils";
import AssistentiService from "../../services/AssistentiService";
import {setParamsRicercaAssistente, setStateRicercaAssistente} from "../../actions/IndexActions";
import AnagraficaService from "../../services/AnagraficaService";
import Spinner from "../../components/spinner/Spinner";
import {useDispatch, useSelector} from "react-redux";
import Feedback from "../feedback/Feedback";

function CercaAssistentiFamiliari(props) {

    const [state, setState] = useState({rangeKm: 10})
    const [stateCopy, setStateCopy] = useState({})
    const [assistentiPerComune, setAssistentiPerComune] = useState([])
    const [anagraficaAssistentePerComune, setAnagraficaAssistentePerComune] = useState([])
    const [comune, setComune] = useState({})
    const [showSpinner, setShowSpinner] = useState(false)
    const [rows, setRows] = useState([])
    const comuni = JSON.parse(sessionStorage.getItem("comuniCoordinate"))
    const province = JSON.parse(sessionStorage.getItem("siglaProvincePerCodice"))
    const dispatch = useDispatch()
    const [countRender, setCountRender] = useState(0)
    const history = useHistory()
    const cols = [
        {name: "Cognome", key: "cognome"},
        {name: "Nome", key: "nome"},
        {name: "Numero di telefono", key: "telefono", type: "telefono", onClickTelefono: onClickTelefono},
        {name: "Disponibilità territoriale", type: "array", keyArray: "descrizione", key: "disponibilitaTerritoriale"},
        {
            type: "button",
            key: "vedi",
            text: "Vedi",
            typeButton: "Blue",
            style: {width: "100px", height: "40px"},
            onClick: onClickButtonTable
        }
    ]
    const [pagination, setPagination] = useState({
        size: 5,
        page: 0,
        sort: "cognome",
        order: "asc",
        totalPages: 1,
        totalElements: rows.length
    })
    const paramsAssistenteReducer = useSelector(state => state.ricercaAssistenteReducer.params)
    const stateAssistenteReducer = useSelector(state => state.ricercaAssistenteReducer.state)
    const [timeoutFunction, setTimeoutFunction] = useState(null)
    const [resetTimeout, setResetTimeout] = useState(0)
    const modalBodyFeedback = useState(<Feedback timeoutFunction={timeoutFunction}/>)
    const comuniPerCodice = JSON.parse(sessionStorage.getItem("comuniPerCodice"))
    const provincePerCodice = JSON.parse(sessionStorage.getItem("provincePerCodice"))
    const siglaProvincePerCodice = JSON.parse(sessionStorage.getItem("siglaProvincePerCodice"))
    const nazioniPerCodice = JSON.parse(sessionStorage.getItem("nazioniPerCodice"))

    useEffect(() => {
        if (history && history.location && history.location.comune && Object.keys(history.location.comune).length !== 0) {
            let newState = {...state}
            newState.comuneRicerca = history.location.comune;
            setState(newState)
            setStateCopy({...newState})
            setComune(newState)
            let paramsAssistente = createParamsAssistente(newState, newState)
            getAssistenti(paramsAssistente)
            setCountRender(countRender + 1)
        } else if (paramsAssistenteReducer && stateAssistenteReducer) {
            setState(stateAssistenteReducer)
            setComune(stateAssistenteReducer)
            getAssistenti(paramsAssistenteReducer)
            setCountRender(countRender + 1)
        }
        timeoutFeedBAck()
    }, [])

    useEffect(() => {
        mapRowTableAssistenti()
    }, [anagraficaAssistentePerComune, setAnagraficaAssistentePerComune])

    useEffect(() => {
    }, [countRender])

    useEffect(() => {
        timeoutFeedBAck()
    }, [resetTimeout])
    function timeoutFeedBAck() {
        if (timeoutFunction) {
            clearTimeout(timeoutFunction);
        }
        let f = setTimeout(function () {
            if (document.getElementById("Feedback")) {
                document.getElementById("Feedback").click();
            }
        }, 180000)
        setTimeoutFunction(f)
    }
    function getAssistenti(paramsAssistente,size,page) {
        setShowSpinner(true)
        if(page){paramsAssistente.page = page}
        if(size){paramsAssistente.size = size}
        dispatch(setParamsRicercaAssistente(paramsAssistente))
        AssistentiService.getAssistenteComuneHome(paramsAssistente).then(resAssistenti => {
            if (resAssistenti.data && resAssistenti.data.assistenti && resAssistenti.data.assistenti.length > 0) {
                setAssistentiPerComune(resAssistenti.data.assistenti)
                let arrayIdAssistenti = extractIdAssistente(resAssistenti.data.assistenti)
                let paramsAnagraficaAssistenti = {}
                paramsAnagraficaAssistenti.idCandidati = arrayIdAssistenti
                let newPagination = {
                    sort: "cognome",
                    order: "asc",
                    size:resAssistenti.data.size,
                    page:resAssistenti.data.page,
                    totalElements: resAssistenti.data.totalElements,
                    totalPages: resAssistenti.data.totalElements <= resAssistenti.data.size ? 1 : Math.ceil(resAssistenti.data.totalElements / resAssistenti.data.size)
                }
                setPagination(newPagination)
                AnagraficaService.getSintesiAssistenti(paramsAnagraficaAssistenti).then(resCandidato => {
                    if (resCandidato && resCandidato.data && resCandidato.data.length > 0) {
                        setAnagraficaAssistentePerComune(resCandidato.data)
                    }
                    setShowSpinner(false)
                }).catch(reason => {
                    setShowSpinner(false)
                    setAnagraficaAssistentePerComune([])
                    console.log("Errore Operation GET Candidato: " + reason)
                })
            } else {
                setShowSpinner(false)
                setAnagraficaAssistentePerComune([])
            }

        }).catch(reason => {
            setShowSpinner(false)
            console.log("Errore Operation GET AssisetenteHome: " + reason)
        })
    }
    function mapRowTableAssistenti() {
        let newRow = []
        for (let i = 0; i < assistentiPerComune.length; i++) {
            for (let j = 0; j < anagraficaAssistentePerComune.length; j++) {
                if (assistentiPerComune[i].idCandidato === anagraficaAssistentePerComune[j].id)
                    newRow.push({
                        cognome: anagraficaAssistentePerComune[j].cognome.toUpperCase(),
                        nome: anagraficaAssistentePerComune[j].nome.toUpperCase(),
                        telefono: anagraficaAssistentePerComune[j].cellulare,
                        disponibilitaTerritoriale: assistentiPerComune[i].lavoroDisponibilita.disponibilitaOfferta.comune,
                        vedi: assistentiPerComune[i].idCandidato
                    })
            }
        }
        for (let i = 0; i < newRow.length; i++) {
            newRow[i].telefono = {
                numero: newRow[i].telefono,
                view: false
            }
        }
        setRows(newRow)
    }
    function onClickTelefono(event) {
        let newRows = rows
        let id = event.target.id
        let i = id.replace("telefono", '');
        newRows[i].telefono.view = true
        setRows(newRows);
        setCountRender(countRender + 1)
    }
    function onClickButtonTable(idCandidato) {
        dispatch(setStateRicercaAssistente(state))
        Utils.recuperaDatiAssistente(idCandidato, dispatch, history, "/profiloAssistente", comuniPerCodice, siglaProvincePerCodice, nazioniPerCodice, provincePerCodice)
    }
    function changePage(newPage) {
        let newPagination = {
            size: pagination.size,
            page: newPage,
            sort: pagination.sort,
            order: pagination.order,
            totalPages: pagination.totalPages,
            totalElements: pagination.totalElements
        }
        setPagination(newPagination)
        getAssistenti(createParamsAssistente(comune, state),pagination.size,newPage)
    }
    function changePaginationSize(sort, direction, page, size) {
        let newPagination = {...pagination};
        if (sort !== null) {
            newPagination.sort = sort
        }
        if (direction !== null) {
            newPagination.order = direction
        }
        newPagination.page = page;
        newPagination.size = parseInt(size);
        newPagination.totalPages = pagination.totalElements <= newPagination.size ? 1 : Math.ceil(pagination.totalElements / newPagination.size)
        setPagination(newPagination)
        getAssistenti(createParamsAssistente(comune, state),newPagination.size,newPagination.page)
    }
    function createParamsAssistente(comuneParam, state) {
        let params = {
            km: state.rangeKm,
            longitudine: comuneParam && comuneParam.comuneRicerca ? comuneParam.comuneRicerca.longitudine : comune.comuneRicerca.longitudine,
            latitudine: comuneParam && comuneParam.comuneRicerca ? comuneParam.comuneRicerca.latitudine : comune.comuneRicerca.latitudine
        }

        if (state && state.tipologia && state.tipologia.maschio) params["maschio"] = state.tipologia.maschio
        if (state && state.tipologia && state.tipologia.femmina) params["femmina"] = state.tipologia.femmina
        if (state && state.tipologia && state.tipologia.autosufficiente) params["autosufficiente"] = state.tipologia.autosufficiente
        if (state && state.tipologia && state.tipologia.carrozzina) params["carrozzina"] = state.tipologia.carrozzina
        if (state && state.tipologia && state.tipologia.allettata) params["allettata"] = state.tipologia.allettata
        if (state && state.tipologia && state.tipologia.parzialmenteAutosufficiente) params["parzialmenteAutosufficiente"] = state.tipologia.parzialmenteAutosufficiente
        if (state && state.tipologia && state.tipologia.disabilita) params["disabilita"] = state.tipologia.disabilita

        if (state && state.disponibilita && state.disponibilita.h24) params["h24"] = state.disponibilita.h24
        if (state && state.disponibilita && state.disponibilita.assistenzaDiurna) params["assistenzaDiurna"] = state.disponibilita.assistenzaDiurna
        if (state && state.disponibilita && state.disponibilita.assistenzaNotturna) params["assistenzaNotturna"] = state.disponibilita.assistenzaNotturna
        if (state && state.disponibilita && state.disponibilita.assistenzaFineSettimana) params["assistenzaFineSettimana"] = state.disponibilita.assistenzaFineSettimana
        if (state && state.disponibilita && state.disponibilita.assistenzaChiamata) params["assistenzaChiamata"] = state.disponibilita.assistenzaChiamata
        if (state && state.disponibilita && state.disponibilita.vitto) params["vitto"] = state.disponibilita.vitto
        if (state && state.disponibilita && state.disponibilita.alloggio) params["alloggio"] = state.disponibilita.alloggio

        if (state && state.ausili && state.ausili.catetere) params["catetere"] = state.ausili.catetere
        if (state && state.ausili && state.ausili.peg) params["peg"] = state.ausili.peg
        if (state && state.ausili && state.ausili.stomia) params["stomia"] = state.ausili.stomia
        if (state && state.ausili && state.ausili.ventilatorePolmonare) params["ventilatorePolmonare"] = state.ausili.ventilatorePolmonare
        if (state && state.ausili && state.ausili.ossigeno) params["ossigeno"] = state.ausili.ossigeno

        if (state && state.mezzo && state.mezzo.patente) params["patente"] = state.mezzo.patente
        if (state && state.mezzo && state.mezzo.automunito) params["automunito"] = state.mezzo.automunito

        return params
    }
    function extractIdAssistente(data) {
        let arrayId = []
        for (let i = 0; i < data.length; i++) {
            arrayId.push(data[i].idCandidato)
        }
        return arrayId
    }
    function onClickButtonRicerca() {
        let newState = {...state}
        newState.comuneRicerca = comune.comuneRicerca
        getAssistenti(createParamsAssistente(comune, state))
        setResetTimeout(resetTimeout + 1)
        let jsonParam = {
            idReport: 1,
            provincia: province[state.comuneRicerca.codiceProvincia].descrizione
        }
        Utils.putReport(jsonParam)
        setState(newState)
        let stateCopy = {}
        stateCopy.tipologia = {...newState.tipologia} ? {...newState.tipologia} : {}
        stateCopy.disponibilita = {...newState.disponibilita} ? {...newState.disponibilita} : {}
        stateCopy.ausili = {...newState.ausili} ? {...newState.ausili} : {}
        stateCopy.mezzo = {...newState.mezzo} ? {...newState.mezzo} : {}
        stateCopy.comuneRicerca = comune.comuneRicerca
        stateCopy.rangeKm = newState.rangeKm
        setStateCopy(stateCopy)
    }
    function onChangeComune(id, value) {
        setComune(Utils.riceviValore(comune, id, value))
    }
    function riceviValore(padre, name, value) {

        let newState = {...state}
        let newValue = {};
        newValue[name] = value

        if (!(newState && newState[padre])) newState[padre] = {}
        Object.assign(newState[padre], newValue);
        setState(newState)

    }
    function applicaFiltri() {
        let newState = {...state}
        let stateCopy = {}
        stateCopy.tipologia = {...newState.tipologia} ? {...newState.tipologia} : {}
        stateCopy.disponibilita = {...newState.disponibilita} ? {...newState.disponibilita} : {}
        stateCopy.ausili = {...newState.ausili} ? {...newState.ausili} : {}
        stateCopy.mezzo = {...newState.mezzo} ? {...newState.mezzo} : {}
        stateCopy.rangeKm = newState.rangeKm
        setStateCopy(stateCopy)
        let newPagination = {...pagination}
        newPagination.page = 0
        setPagination(newPagination)
        getAssistenti(createParamsAssistente(comune, state),pagination.size,newPagination.page)
    }
    function onClickAnteprima() {
        setShowSpinner(true)
        let paramsAssistente = createParamsAssistente(comune, stateCopy)
        paramsAssistente.formato = "pdf"
        paramsAssistente.comuneRicerca = comune.comuneRicerca.descrizione
        AssistentiService.getExportFileHome(paramsAssistente).then(res => {
            Utils.visualizzaPdf(res.data.stream, res.data.descrizione, res.data.formato)
            setShowSpinner(false)
        }).catch(reason => {
            console.log("Errore Operation GET Export File: " + reason)
            setShowSpinner(false)
        })
    }
    function onClickSalvaCsv() {
        setShowSpinner(true)
        let paramsAssistente = createParamsAssistente(comune, stateCopy)
        paramsAssistente.formato = "csv"
        paramsAssistente.comuneRicerca = comune.comuneRicerca.descrizione
        AssistentiService.getExportFileHome(paramsAssistente).then(res => {
            Utils.downloadReport(res.data.stream, res.data.descrizione, res.data.formato)
            setShowSpinner(false)
        }).catch(reason => {
            console.log("Errore Operation GET Export File: " + reason)
            setShowSpinner(false)
        })
    }
    function labelApplicaFiltri() {
        let numeroFiltri = 0
        let filtriState = {}

        filtriState.disponibilita = state && state.disponibilita ? {...state.disponibilita} : {}
        filtriState.ausili = state && state.ausili ? {...state.ausili} : {}
        filtriState.mezzo = state && state.mezzo ? {...state.mezzo} : {}
        filtriState.tipologia = state && state.tipologia ? {...state.tipologia} : {}

        for (let key in filtriState) {
            for (let keyInterna in filtriState[key]) {
                if (filtriState[key] && filtriState[key][keyInterna]) numeroFiltri = numeroFiltri + 1
            }
        }


        return "Applica (".concat(numeroFiltri).concat(") filtro/i")
    }
    function setPaginationSort(sort, order) {
        let newPagination = {...pagination}
        newPagination.sort = sort
        newPagination.order = order
        setPagination(newPagination)
    }

    return (
        <div className={style.marginInitial}>
            <Spinner show={showSpinner}/>
            <Row>
                <div className={"col-3"}>
                    <p style={{fontSize: "19px", marginTop: "5px"}}>Trova il tuo Assistente Familiare a</p>
                </div>
                <div className={"col-3"}>
                    <Autocomplete
                        id={"comuneRicerca"}
                        value={state && state.comuneRicerca ? state.comuneRicerca : ""}
                        onChange={onChangeComune}
                        placeholder={"Comune"}
                        suggestions={comuni}
                        rerender={countRender}
                    />
                </div>
                <div className={"col-1"}>
                    <Button
                        typeButton={"Blue"}
                        onClick={onClickButtonRicerca}
                        style={{width: "100%", height: "2.5rem", borderLeft: "none", fontSize: "16px"}}
                        text={"Cerca"}
                        disabled={!(comune && comune.comuneRicerca)}
                    />
                </div>
            </Row>

            <Row>
                <fieldset
                    disabled={!(state && state.comuneRicerca && comune && comune.comuneRicerca) || state.comuneRicerca.descrizione !== comune.comuneRicerca.descrizione}>
                    <div className={"col-2 ".concat(style.marginInitial)}
                         style={{
                             minWidth: "310px",
                             border: "1px solid grey",
                             opacity: !(state && state.comuneRicerca && comune && comune.comuneRicerca) || state.comuneRicerca.descrizione !== comune.comuneRicerca.descrizione ? "0.5" : "1"
                         }}>
                        <div style={{marginTop: "20px", textAlign: "center"}}>
                            <Button typeButton={"Blue"}
                                    text={labelApplicaFiltri()}
                                    style={{width: "140px", height: "40px", fontSize: "15px"}}
                                    onClick={() => applicaFiltri()}
                            />
                        </div>
                        <div style={{marginTop: "20px", marginLeft: "25px"}}>
                            <RangeSlider value={state.rangeKm} id={"rangeKm"}
                                         onChange={(event) => setState(Utils.riceviValore(state, event.target.id, event.target.value))}
                            />
                        </div>

                        <div className="sidebar-linklist-wrapper" style={{marginTop: "20px"}}>
                            <div className="link-list-wrapper">
                                <ul className="link-list">
                                    <li>
                                        <a className={"list-item large medium right-icon ".concat(style.intestazioneFiltri)}
                                           href="#collapseZero"
                                           data-toggle="collapse" aria-expanded="false" aria-controls="collapseZero">
                                            <svg width={"36"} height={"36"} fill={"#1b7ea9"} viewBox="0 0 24 24"
                                                 id="it-arrow-down-triangle" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9.2 12h5.6a1 1 0 01.7 1.7L12 17.3l-3.5-3.6a1 1 0 01.7-1.7z"/>
                                                <path fill="none" d="M0 0h24v24H0z"/>
                                            </svg>
                                            <span style={{fontSize: "14px", color: "black", fontWeight: "normal"}}>Tipologia persona da assistere</span>
                                        </a>
                                        <ul className="link-sublist collapse show" id="collapseZero">
                                            <CheckBox classNameText={style.checkBoxText} text={"M"} id={"maschio"}
                                                      checked={state && state.tipologia && state.tipologia.maschio ? state.tipologia.maschio : ""}
                                                      onChange={(event) => riceviValore("tipologia", event.target.id, event.target.checked)}/>
                                            <CheckBox classNameText={style.checkBoxText} text={"F"} id={"femmina"}
                                                      checked={state && state.tipologia && state.tipologia.femmina ? state.tipologia.femmina : ""}
                                                      onChange={(event) => riceviValore("tipologia", event.target.id, event.target.checked)}/>
                                            <CheckBox classNameText={style.checkBoxText} text={"Autosufficiente"}
                                                      id={"autosufficiente"}
                                                      checked={state && state.tipologia && state.tipologia.autosufficiente ? state.tipologia.autosufficiente : ""}
                                                      onChange={(event) => riceviValore("tipologia", event.target.id, event.target.checked)}/>
                                            <CheckBox classNameText={style.checkBoxText}
                                                      text={"Parzialmente autosufficiente"}
                                                      id={"parzialmenteAutosufficiente"}
                                                      checked={state && state.tipologia && state.tipologia.parzialmenteAutosufficiente ? state.tipologia.parzialmenteAutosufficiente : ""}
                                                      onChange={(event) => riceviValore("tipologia", event.target.id, event.target.checked)}/>
                                            <CheckBox classNameText={style.checkBoxText} text={"In carrozzina"}
                                                      id={"carrozzina"}
                                                      checked={state && state.tipologia && state.tipologia.carrozzina ? state.tipologia.carrozzina : ""}
                                                      onChange={(event) => riceviValore("tipologia", event.target.id, event.target.checked)}/>
                                            <CheckBox classNameText={style.checkBoxText} text={"Allettata"}
                                                      id={"allettata"}
                                                      checked={state && state.tipologia && state.tipologia.allettata ? state.tipologia.allettata : ""}
                                                      onChange={(event) => riceviValore("tipologia", event.target.id, event.target.checked)}/>
                                            <CheckBox classNameText={style.checkBoxText}
                                                      text={"Affetta da disabilità mentale"} id={"disabilita"}
                                                      checked={state && state.tipologia && state.tipologia.disabilita ? state.tipologia.disabilita : ""}
                                                      onChange={(event) => riceviValore("tipologia", event.target.id, event.target.checked)}/>
                                        </ul>
                                    </li>
                                    <li>
                                        <a className={"list-item large medium right-icon ".concat(style.intestazioneFiltri)}
                                           href="#collapseOne"
                                           data-toggle="collapse" aria-expanded="false" aria-controls="collapseOne">
                                            <svg width={"36"} height={"36"} fill={"#1b7ea9"} viewBox="0 0 24 24"
                                                 id="it-arrow-down-triangle" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9.2 12h5.6a1 1 0 01.7 1.7L12 17.3l-3.5-3.6a1 1 0 01.7-1.7z"/>
                                                <path fill="none" d="M0 0h24v24H0z"/>
                                            </svg>
                                            <span style={{fontSize: "14px", color: "black", fontWeight: "normal"}}>Disponibilità oraria</span>
                                        </a>
                                        <ul className="link-sublist collapse show" id="collapseOne">
                                            <CheckBox classNameText={style.checkBoxText} text={"Assistenza diurna"}
                                                      id={"assistenzaDiurna"}
                                                      checked={state && state.disponibilita && state.disponibilita.assistenzaDiurna ? state.disponibilita.assistenzaDiurna : ""}
                                                      onChange={(event) => riceviValore("disponibilita", event.target.id, event.target.checked)}/>
                                            <CheckBox classNameText={style.checkBoxText} text={"Assistenza notturna"}
                                                      id={"assistenzaNotturna"}
                                                      checked={state && state.disponibilita && state.disponibilita.assistenzaNotturna ? state.disponibilita.assistenzaNotturna : ""}
                                                      onChange={(event) => riceviValore("disponibilita", event.target.id, event.target.checked)}/>
                                            <CheckBox classNameText={style.checkBoxText}
                                                      text={"Assistenza fine settimana"} id={"assistenzaFineSettimana"}
                                                      checked={state && state.disponibilita && state.disponibilita.assistenzaFineSettimana ? state.disponibilita.assistenzaFineSettimana : ""}
                                                      onChange={(event) => riceviValore("disponibilita", event.target.id, event.target.checked)}/>
                                            <CheckBox classNameText={style.checkBoxText} text={"Assistenza ad ore"}
                                                      id={"assistenzaChiamata"}
                                                      checked={state && state.disponibilita && state.disponibilita.assistenzaChiamata ? state.disponibilita.assistenzaChiamata : ""}
                                                      onChange={(event) => riceviValore("disponibilita", event.target.id, event.target.checked)}/>
                                            <CheckBox classNameText={style.checkBoxText} text={"24h/24"}
                                                      id={"h24"}
                                                      checked={state && state.disponibilita && state.disponibilita.h24 ? state.disponibilita.h24 : ""}
                                                      onChange={(event) => riceviValore("disponibilita", event.target.id, event.target.checked)}/>
                                            <CheckBox classNameText={style.checkBoxText} text={"Con alloggio"}
                                                      id={"alloggio"}
                                                      checked={state && state.disponibilita && state.disponibilita.alloggio ? state.disponibilita.alloggio : ""}
                                                      onChange={(event) => riceviValore("disponibilita", event.target.id, event.target.checked)}/>
                                            <CheckBox classNameText={style.checkBoxText} text={"Con vitto"}
                                                      id={"vitto"}
                                                      checked={state && state.disponibilita && state.disponibilita.vitto ? state.disponibilita.vitto : ""}
                                                      onChange={(event) => riceviValore("disponibilita", event.target.id, event.target.checked)}/>
                                        </ul>
                                    </li>
                                    <li>
                                        <a className={"list-item large medium right-icon ".concat(style.intestazioneFiltri)}
                                           href="#collapseTwo" data-toggle="collapse"
                                           aria-expanded="false" aria-controls="collapseTwo">
                                            <svg width={"36"} height={"36"} fill={"#1b7ea9"} viewBox="0 0 24 24"
                                                 id="it-arrow-down-triangle" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9.2 12h5.6a1 1 0 01.7 1.7L12 17.3l-3.5-3.6a1 1 0 01.7-1.7z"/>
                                                <path fill="none" d="M0 0h24v24H0z"/>
                                            </svg>
                                            <span style={{fontSize: "14px", color: "black", fontWeight: "normal"}}>Utilizzo di ausili</span>
                                        </a>
                                        <ul className="link-sublist collapse show" id="collapseTwo">
                                            <CheckBox classNameText={style.checkBoxText} text={"Catetere"}
                                                      id={"catetere"}
                                                      checked={state && state.ausili && state.ausili.catetere ? state.ausili.catetere : ""}
                                                      onChange={(event) => riceviValore("ausili", event.target.id, event.target.checked)}/>
                                            <CheckBox classNameText={style.checkBoxText} text={"Ossigeno"}
                                                      id={"ossigeno"}
                                                      checked={state && state.ausili && state.ausili.ossigeno ? state.ausili.ossigeno : ""}
                                                      onChange={(event) => riceviValore("ausili", event.target.id, event.target.checked)}/>
                                            <CheckBox classNameText={style.checkBoxText} text={"Ventilatore polmonare"}
                                                      id={"ventilatorePolmonare"}
                                                      checked={state && state.ausili && state.ausili.ventilatorePolmonare ? state.ausili.ventilatorePolmonare : ""}
                                                      onChange={(event) => riceviValore("ausili", event.target.id, event.target.checked)}/>
                                            <CheckBox classNameText={style.checkBoxText} text={"Stomia"} id={"stomia"}
                                                      checked={state && state.ausili && state.ausili.stomia ? state.ausili.stomia : ""}
                                                      onChange={(event) => riceviValore("ausili", event.target.id, event.target.checked)}/>
                                            <CheckBox classNameText={style.checkBoxText} text={"PEG"} id={"peg"}
                                                      checked={state && state.ausili && state.ausili.peg ? state.ausili.peg : ""}
                                                      onChange={(event) => riceviValore("ausili", event.target.id, event.target.checked)}/>
                                        </ul>
                                    </li>
                                    <li>
                                        <a className={"list-item large medium right-icon ".concat(style.intestazioneFiltri)}
                                           href="#collapseThree" data-toggle="collapse"
                                           aria-expanded="false" aria-controls="collapseThree">
                                            <svg width={"36"} height={"36"} fill={"#1b7ea9"} viewBox="0 0 24 24"
                                                 id="it-arrow-down-triangle" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9.2 12h5.6a1 1 0 01.7 1.7L12 17.3l-3.5-3.6a1 1 0 01.7-1.7z"/>
                                                <path fill="none" d="M0 0h24v24H0z"/>
                                            </svg>
                                            <span style={{fontSize: "14px", color: "black", fontWeight: "normal"}}>Mezzo di trasporto</span>
                                        </a>
                                        <ul className="link-sublist collapse show" id="collapseThree">
                                            <CheckBox classNameText={style.checkBoxText} text={"Patente"} id={"patente"}
                                                      checked={state && state.mezzo && state.mezzo.patente ? state.mezzo.patente : ""}
                                                      onChange={(event) => riceviValore("mezzo", event.target.id, event.target.checked ? "1" : false)}/>
                                            <CheckBox classNameText={style.checkBoxText} text={"Automunita/o"}
                                                      id={"automunito"}
                                                      checked={state && state.mezzo && state.mezzo.automunito ? state.mezzo.automunito : ""}
                                                      onChange={(event) => riceviValore("mezzo", event.target.id, event.target.checked ? "1" : false)}/>
                                        </ul>
                                    </li>
                                    <li style={{textAlign: "center", marginTop: "5%"}}>
                                        <Button typeButton={"Blue"}
                                                text={labelApplicaFiltri()}
                                                style={{width: "140px", height: "40px", fontSize: "15px"}}
                                                onClick={() => applicaFiltri()}
                                        />
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </fieldset>

                <div className={"col ".concat(style.marginInitial)} style={{overflowX: "auto", paddingLeft: "20px"}}>
                    <Table
                        cols={cols}
                        rows={rows}
                        id={"tabellaProva"}
                        allegati={true}
                        pagination={true}
                        changePage={changePage}
                        setSort={setPaginationSort}
                        sizeElementView={true}
                        size={pagination.size}
                        changePaginationSize={changePaginationSize}
                        onClickAnteprima={onClickAnteprima}
                        onClickSalvaCsv={onClickSalvaCsv}
                    />
                    <Pagination pagination={pagination} page={pagination.page} changePage={changePage}/>
                </div>

                <div>
                    <Button
                        id={"Feedback"}
                        typeButton={"Blue"}
                        style={{display: "none"}}
                        dataTarget={"modaleFeedback"}
                        dataToggle={"modal"}
                        dataBackdrop={"static"}
                        dataKeyboard={false}
                        body={modalBodyFeedback}
                        header={"Feedback"}
                    />
                </div>

            </Row>
        </div>


    )


}

export default CercaAssistentiFamiliari